"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconNotification = function IconNotification(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M27.21 6.32a4.52 4.52 0 0 1 1.33 3.504c3.43 1.345 6.242 4.448 6.46 10.116V28a3 3 0 0 0 .5 1.67l.892 1.33H38v6H10v-6h1.605l.895-1.33A3 3 0 0 0 13 28v-8c.226-5.717 3.063-8.844 6.512-10.189a4.48 4.48 0 0 1 1.338-3.49 4.2 4.2 0 0 1 1.43-1 4.52 4.52 0 0 1 3.5 0 4.2 4.2 0 0 1 1.43 1m6.63 24.45.153.23H14.006l.154-.23A5 5 0 0 0 15 28v-8c.34-8.12 6.41-9 9-9 8 0 8.91 6.93 9 9v8a5 5 0 0 0 .84 2.77M24 9c-.823 0-1.657.075-2.48.234A2.52 2.52 0 0 1 23 7.2a2.5 2.5 0 0 1 2 0 2.52 2.52 0 0 1 1.48 2.032A13 13 0 0 0 24 9m-5 29a5 5 0 1 0 10 0h-2a3 3 0 1 1-6 0zm17-3H12v-2h24zm-9.46-21.08.38-.92c2.8.89 4.4 3.31 4.57 7.05h-1c-.16-3.3-1.49-5.35-3.95-6.13",
    clipRule: "evenodd"
  })));
};

export { IconNotification, IconNotification as default };
